var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "gallery" } },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.$route.query.gallery
          ? _c(
              "div",
              { staticClass: "main-container" },
              [
                _c("gallery", {
                  attrs: { images: _vm.images, index: _vm.imageIndex },
                  on: { close: _vm.closed }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15c1b052", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15c1b052","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = 482
// module chunks = 4